import React from 'react';
import { Section } from '../ui/Section';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function ProductReveal() {
  const notList = ['Productividad extrema', 'Rutinas imposibles', 'Hábitos rígidos', '“Poder con todo”'];
  const yesList = ['Alivio', 'Claridad', 'Menos exigencia', 'Energía real para una vida real'];
  return <Section background="white" className="text-center overflow-hidden" data-id="element-242">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} data-id="element-243">
        <h2 className="text-3xl md:text-5xl font-black text-slate-900 mb-12" data-id="element-244">
          Antes de seguir, esto es importante
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-245">
          {/* NO ES */}
          <div className="bg-rose-50 p-8 rounded-3xl border border-rose-100" data-id="element-246">
            <h3 className="text-2xl font-black text-rose-600 mb-6 uppercase tracking-wide" data-id="element-247">
              Esto NO es
            </h3>
            <div className="space-y-4" data-id="element-248">
              {notList.map((item, i) => <div key={i} className="flex items-center gap-3 bg-white p-4 rounded-xl shadow-sm" data-id="element-249">
                  <X className="w-5 h-5 text-rose-500 flex-shrink-0" data-id="element-250" />
                  <span className="text-lg font-medium text-slate-700" data-id="element-251">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>

          {/* SI ES */}
          <div className="bg-emerald-50 p-8 rounded-3xl border border-emerald-100" data-id="element-252">
            <h3 className="text-2xl font-black text-emerald-600 mb-6 uppercase tracking-wide" data-id="element-253">
              Esto SÍ es
            </h3>
            <div className="space-y-4" data-id="element-254">
              {yesList.map((item, i) => <div key={i} className="flex items-center gap-3 bg-white p-4 rounded-xl shadow-sm" data-id="element-255">
                  <Check className="w-5 h-5 text-emerald-500 flex-shrink-0" data-id="element-256" />
                  <span className="text-lg font-medium text-slate-700" data-id="element-257">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </motion.div>
    </Section>;
}